export const GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS = "GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS";
export const GET_CATEGORIES_MARKETPLACE_PRODUCTS = "GET_CATEGORIES_MARKETPLACE_PRODUCTS";
export const GET_COMPANIES_LIST_TYPE_DOCUMENT = "GET_COMPANIES_LIST_TYPE_DOCUMENT";
export const GET_ALL_MONETIZATION_TYPES = "GET_ALL_MONETIZATION_TYPES";
export const GET_COMPANIES_BY_ID = "GET_COMPANIES_BY_ID";
export const GET_FUNCTIONALITIES = "GET_FUNCTIONALITIES";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_COMPANIES = "GET_COMPANIES";